import { render, staticRenderFns } from "./orderSet.vue?vue&type=template&id=19ba0154&scoped=true"
import script from "./orderSet.vue?vue&type=script&lang=js"
export * from "./orderSet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ba0154",
  null
  
)

export default component.exports